import { useCallback, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Dispatch } from 'redux';

import { Modal } from '../../../UIPackage/ModalModule/components/Modal';
import { ModalHeader } from '../../../UIPackage/ModalModule/components/ModalHeader';
import { ModalBody } from '../../../UIPackage/ModalModule/components/ModalBody';
import { ModalActions } from '../../../UIPackage/ModalModule/components/ModalActions';
import { Button } from '../../../UIPackage/MainModule/components/Button';
import { IKnmAttachment } from '../../../APIPackage/KnmModule/interfaces/IKnmAttachment';
import { RootActions } from '../../../CorePackage/MainModule/types/RootActions';
import {
  passportGroupApplySuccessSelector,
  passportGroupSelector,
} from '../../../PassportGroupPackage/MainModule/selectors/passportGroupSelector';
import { REQUIRED_ERROR } from '../../../CorePackage/MainModule/constants/validationErrors';
import { IPassportGroupApplyByKnoRequest } from '../../../APIPackage/PassportGroupsModule/interfaces/IPassportGroupApplyByKnoRequest';
import {
  passportGroupApplyByKnoAction,
  passportGroupSetApplySuccessAction,
} from '../../../PassportGroupPackage/MainModule/actions/passportGroupActions';
import { PassportGroupFileInput } from './PassportGroupFileInput';
import { InfoBlock } from '../../../CorePackage/MainModule/components/InfoBlock';

interface IPassportMassCancellationByKnoModalProps {
  onClose: () => void;
  passportIds: number[];
}

export const PassportMassCancellationByKnoModal = ({
  onClose,
  passportIds,
}: IPassportMassCancellationByKnoModalProps) => {
  const dispatch = useDispatch<Dispatch<RootActions>>();
  const group = useSelector(passportGroupSelector);
  const [attachment, setAttachment] = useState<IKnmAttachment>();
  const [isShowErrors, setIsShowErrors] = useState(false);
  const isApplySuccess = useSelector(passportGroupApplySuccessSelector);

  useEffect(() => {
    if (isApplySuccess) {
      dispatch(passportGroupSetApplySuccessAction(false));
      onClose();
    }
  }, [isApplySuccess, dispatch, onClose]);

  const handleSubmit = useCallback(() => {
    setIsShowErrors(true);

    if (group?.isDecisionRequired && !attachment) {
      return;
    }

    const data: IPassportGroupApplyByKnoRequest = {
      decisionFile: attachment || null,
      passportIds,
    };

    group && dispatch(passportGroupApplyByKnoAction(group.id, data));
  }, [setIsShowErrors, attachment, group, passportIds]);

  return (
    <Modal visible onClose={onClose}>
      <ModalHeader title="Массовая отмена мероприятий" />
      <ModalBody size="content">
        <InfoBlock iconVerticalPosition="top" marginBottom="1.25rem">
          Внимание! Мероприятия будут переведены в статус «Отменено». Если Вы уверены, что хотите отменить все
          мероприятия, нажмите «Подтвердить». Если Вы не хотите отменять мероприятия, нажмите «Назад»
        </InfoBlock>
        {group?.isDecisionRequired && (
          <>
            <PassportGroupFileInput
              label="Файл решения об отмене"
              attachment={attachment}
              setAttachment={setAttachment}
            />
            {isShowErrors && !attachment && <span className="shared-input-error">{REQUIRED_ERROR}</span>}
          </>
        )}
      </ModalBody>
      <ModalActions>
        <Button text="Подтвердить" onClick={handleSubmit} size="medium" color="primary" />
        <Button text="Назад" onClick={onClose} size="medium" />
      </ModalActions>
    </Modal>
  );
};
